import React, { useCallback, useEffect, useState } from "react";
import Layout from "../../../componentes/Comunes/Layout/Layout";
import PageHeading from "../../../componentes/Comunes/PageHeading";
import ServicioComun from "../../../servicios/Comun";
import servicioCambiosCic from "../../../servicios/servicioCambiosCic";
import { Notificar } from "../../../componentes/Comunes/Notificador";
import OperacionesCambioCic from "../../../componentes/CambiosCic/OperacionesCambioCic";
import PadronServicio from "../../../servicios/Padron";
import SolicitudCambioCic from "../../../componentes/CambiosCic/SolicitudCambioCic";
import servicioBDLocal from "../../../servicios/servicioBDLocal";
import servicioUsuario from "../../../servicios/servicioUsuario";
import TipoPersonaDropdown from "../../../componentes/Comunes/Dropdowns/TiposPersona/TipoPersonaDropdown";

function SolicitarModificacion() {
  const [entidades, setEntidades] = useState([]);
  const [entidad, setEntidad] = useState("0");
  const [tipoPersona, setTipoPersona] = useState("0");
  const [tiposSolicitud, setTiposSolicitud] = useState([]);
  const [tipoSolicitudSeleccionada, setTipoSolicitudSeleccionada] = useState(0);
  const [tipoSolicitud, setTipoSolicitud] = useState(0);
  const [identificacion, setIdentificacion] = useState("");
  const [deudor, setDeudor] = useState();
  const [operaciones, setOperaciones] = useState([]);
  const [mostrarResultados, setMostrarResultados] = useState(false);
  const [pasoActual, setPasoActual] = useState(1);
  const [operacionesSolicitud, setOperacionesSolicitud] = useState([]);
  const [tieneSolicitudPendiente, setTieneSolicitudPendiente] = useState(false);

  useEffect(() => {
    async function CargarEntidades() {
      const entidades =
        await ServicioComun.ObtengaEntidadesPrincipalYRelacionadas();
      setEntidades(entidades);
      setEntidad(entidades[0].id);
    }

    CargarEntidades();
  }, []);

  useEffect(() => {
    async function CargarTiposSolicitud() {
      const tiposSolicitud = await ServicioComun.ObtengaTiposSolicitudCambio();
      setTiposSolicitud(tiposSolicitud);
    }

    CargarTiposSolicitud();
  }, []);

  useEffect(() => {
    async function verificarSiTieneSolicitudPendiente() {
      const solicitud = await servicioBDLocal.getData(
        servicioBDLocal.Stores.SolicitudesCambioCicEnConstruccion,
        (
          await servicioUsuario.obtenerUsuarioDelSistema()
        ).identificacion
      );

      if (solicitud) {
        setTieneSolicitudPendiente(true);
      }
    }

    verificarSiTieneSolicitudPendiente();
  }, []);

  async function crearNuevaSolicitud() {
    servicioBDLocal.deleteData(
      servicioBDLocal.Stores.SolicitudesCambioCicEnConstruccion,
      (await servicioUsuario.obtenerUsuarioDelSistema()).identificacion
    );
    setTieneSolicitudPendiente(false);
  }

  async function ObtenerOperaciones() {
    if (tipoSolicitudSeleccionada === 0) {
      Notificar("error", "Debe seleccionar el tipo de solicitud.");
      return;
    }

    obtenerDeudor();
    setMostrarResultados(false);

    const resultado = await obtenerOperacionesCambiosCic();

    if (!resultado.esValido) {
      Notificar("error", resultado.errores);
      return;
    }

    setTipoSolicitud(tipoSolicitudSeleccionada);
    setOperaciones(resultado.operaciones);
    setMostrarResultados(true);
  }

  async function obtenerOperacionesCambiosCic() {
    const parametro = {
      entidad: entidad,
      deudor: {
        codigo: identificacion,
        tipoPersona: {
          codigo: tipoPersona === 0 ? null : tipoPersona,
        },
      },
    };
    const resultado = await servicioCambiosCic.obtenerOperacionesCambiosCic(
      parametro,
      tipoSolicitudSeleccionada
    );
    return resultado;
  }

  function limpiarFiltros() {
    setEntidad(entidades[0].id);
    setIdentificacion("");
    setTipoPersona("0");
    setTipoSolicitudSeleccionada(0);
  }

  async function obtenerDeudor() {
    setDeudor();
    const deudor = await PadronServicio.ObtengaPersonaUnificada({
      Codigo: identificacion,
      TipoPersona: {
        Codigo: tipoPersona === 0 ? null : tipoPersona,
      },
    });

    setDeudor(deudor);
  }

  function iniciarSolicitud() {
    if (operacionesSolicitud.length === 0) {
      Notificar("error", "Debe seleccionar al menos una operación");
      return;
    }

    setPasoActual(2);
  }

  const actualizarOperaciones = useCallback((operaciones) => {
    setOperacionesSolicitud(operaciones);
  }, []);

  return (
    <Layout>
      {pasoActual === 1 ? (
        <>
          <PageHeading title="Solicitar Modificación al CIC" />

          {tieneSolicitudPendiente ? (
            <div className="alert alert-primary text-center py-4">
              <h4 className="alert-heading">
                Existe una solicitud pendiente de completar
              </h4>
              <p>¿Desea continuar con la solicitud?</p>
              <button
                className="btn btn-primary"
                onClick={() => setPasoActual(2)}
              >
                Continuar Solicitud
              </button>
              <br />
              <button
                className="btn btn-sm btn-link font-weight-bold mt-3"
                onClick={crearNuevaSolicitud}
              >
                <u>Ingresar una nueva solicitud</u>
              </button>
            </div>
          ) : (
            <div className="card shadow mb-4">
              <div className="card-header">
                <h6 className="m-0 font-weight-bold text-primary">
                  Filtros de Búsqueda
                </h6>
              </div>
              <div className="card-body">
                <div className="row">
                  {entidades.length > 1 && (
                    <div className="form-group col-md">
                      <label htmlFor="entidad">Entidad</label>
                      <select
                        className="form-control"
                        id="entidad"
                        name="entidad"
                        value={entidad}
                        onChange={(e) => setEntidad(e.target.value)}
                      >
                        {entidades.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.alias}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  <div className="form-group col-md">
                    <label htmlFor="tipoPersona">Tipo Persona</label>
                    <TipoPersonaDropdown
                      id="tipoPersona"
                      name="tipoPersona"
                      value={tipoPersona}
                      onChange={(e) => setTipoPersona(e.target.value)}
                    />
                  </div>
                  <div className="form-group col-md">
                    <label htmlFor="identificacion">Identificación</label>
                    <input
                      className="form-control text-box single-line"
                      id="identificacion"
                      name="identificacion"
                      type="text"
                      maxLength="30"
                      value={identificacion}
                      onChange={(e) => setIdentificacion(e.target.value)}
                    />

                    {/* <h5 id="NombreDeudor">
                      <span className="badge badge-primary">
                        {deudor?.nombreCompleto}
                      </span>
                    </h5> */}
                  </div>
                  <div className="form-group col-md">
                    <label htmlFor="tipoSolicitud">Tipo de Solicitud</label>
                    <select
                      className="form-control"
                      id="tipoSolicitud"
                      name="tipoSolicitud"
                      value={tipoSolicitudSeleccionada}
                      onChange={(e) =>
                        setTipoSolicitudSeleccionada(Number(e.target.value))
                      }
                    >
                      <option value="0" disabled>
                        [Tipo de Solicitud]
                      </option>
                      {tiposSolicitud.map((item) => (
                        <option key={item.codigo} value={item.codigo}>
                          {item.descripcion}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="row col-sm-12">
                  <button
                    id="btnBuscarIdentificaciones"
                    onClick={ObtenerOperaciones}
                    type="button"
                    className="btn btn-primary btn-icon-split"
                  >
                    <span className="icon text-white-50">
                      <i className="fas fa-search"></i>
                    </span>
                    <span className="text">Buscar</span>
                  </button>

                  <button
                    id="btnLimpiarFiltros"
                    onClick={limpiarFiltros}
                    type="button"
                    className="btn btn-sm btn-light ml-3"
                  >
                    <i className="fas fa-redo fa-sm mr-1"></i>
                    Limpiar filtros
                  </button>

                  <div className="col-4">
                    <h4 id="NombreDeudor">
                      <span className="badge badge-second">
                         {deudor?.nombreCompleto != null ? "Nombre: " + deudor?.nombreCompleto: null}
                      </span>
                    </h4>
                  </div>

                </div>

              </div>
            </div>
          )}

          {mostrarResultados ? (
            <>
              <OperacionesCambioCic
                operaciones={operaciones}
                tipoSolicitud={tipoSolicitud}
                actualizarOperaciones={actualizarOperaciones}
              />

              {operaciones.length > 0 ? (
                <div className="text-center mb-5">
                  <button
                    type="button"
                    className="btn btn-primary btn-icon-split"
                    onClick={iniciarSolicitud}
                  >
                    <span className="text">Iniciar Solicitud</span>
                    <span className="icon text-white-50">
                      <i className="fas fa-arrow-alt-circle-right"></i>
                    </span>
                  </button>
                </div>
              ) : null}
            </>
          ) : null}
        </>
      ) : null}

      {pasoActual === 2 ? (
        <SolicitudCambioCic
          entidad={entidad}
          tipoSolicitud={tipoSolicitud}
          deudor={deudor}
          operaciones={operacionesSolicitud}
        />
      ) : null}
    </Layout>
  );
}

export default SolicitarModificacion;
